import React from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

// import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';

import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

import InputAdornment from '@mui/material/InputAdornment';

import { NumericFormat } from 'react-number-format';

// import Switch from '@mui/material/Switch';

export default class NumberInput extends React.Component {
	
	state = {
		displayValue: this.props.defaultValue || 0
	};
	
	lastSucessfulDisplayValue = this.state.displayValue;
	disabled = this.props.disabled || false;
	step = this.props.step || 1;
	max = this.props.max || Number.MAX_VALUE;
	min = this.props.min || Number.MIN_VALUE;
	prefix = this.props.prefix;
	suffix = this.props.suffix;
	width = this.props.width;
	onCommit = this.props.onCommit;
	
	render() {
		const onTextInputChanged = (event) => {
			this.setState({displayValue: event.target.value});
		};
		
		const validateAndUpdateInput = (allowNegative=false, showNegative=false) => {
			var newValue = parseInt(this.state.displayValue);
			
			if (isNaN(newValue)) {
				newValue = this.lastSucessfulDisplayValue;
				// if (isNaN(this.lastSucessfulDisplayValue)) {
					// newValue = 0;
				// } else {
					// newValue = this.lastSucessfulDisplayValue;
				// }
			}
			
			newValue = Math.min(Math.max(newValue, this.min), this.max);
			
			this.setState({displayValue: newValue}, () => {
				this.lastSucessfulDisplayValue = this.state.displayValue;

				this.onCommit(this.state.displayValue);
			});
		};
		
		const decrement = () => {
			this.setState(
				{displayValue: this.state.displayValue - this.step},
				() => validateAndUpdateInput(true, true)
			);
			
		}
		
		const increment = () => {
			this.setState(
				{displayValue: this.state.displayValue + this.step},
				() => validateAndUpdateInput(true, true)
			);
		}
		
		const RenderAdornment = () => {
			var html = []
			
			if (this.prefix != null) {
				html.push(<InputAdornment>{this.prefix}</InputAdornment>)
			}
			
			if (this.suffix != null) {
				html.push(<InputAdornment>{this.suffix}</InputAdornment>)
			}
			
			return html;
		}
		
		return (
			<Stack direction="row" sx={{width: this.width}} >
				<IconButton disabled={this.disabled} onClick={ decrement } size="small" sx={{width:"40px", height:"40px", margin:"auto auto"}}>
					<RemoveIcon sx={{ color: this.disabled? "#BDBDBD" : "black", width:"100%", height:"100%"}} />
				</IconButton>
					
				<TextField
					variant="standard"
					value={ this.state.displayValue }
					disabled={this.disabled}
					
					onChange={ 
						(event)=>onTextInputChanged(event, "displayValue")
					} 
					
					onBlur={ 
						(event)=>validateAndUpdateInput(true, true)
					}
					
					sx={{
						width:"auto",
					}}
					
					inputProps={ { style: { textAlign: 'center'}} }
					InputProps={{ 
						style: { textAlign: 'center'},
						startAdornment: this.prefix? (<InputAdornment position="start">{this.prefix}</InputAdornment>) : null,
						endAdornment:  this.suffix? (<InputAdornment position="end">{this.suffix}</InputAdornment>) : null,
					}}
				/>
				
				<IconButton disabled={this.disabled} onClick={ increment } size="small" sx={{width:"40px", height:"40px", margin:"auto auto"}}>
					<AddIcon sx={{ color: this.disabled? "#BDBDBD" : "black", width:"100%", height:"100%"}} />
				</IconButton>
			</Stack>
		);
	}
}